import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { User } from "@types";

/**
 * Hook to fetch users with ExamAdmin or TermAdmin roles.
 * Used for Contact Person and Exam Assessor dropdowns in exam term forms.
 */
export const useGetAdminUsers = () => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchAdminUsers = async () => {
        try {
            // Filter users by ExamAdmin and TermAdmin roles
            const { data } = await axios.get<{ items: User[] }>("/api/users", {
                params: {
                    roles: ["ExamAdmin", "TermAdmin"]
                },
                paramsSerializer: {
                    indexes: null // This ensures roles are serialized as roles=ExamAdmin&roles=TermAdmin
                }
            });
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getUsers"));
        }
    };

    return useQuery({
        queryKey: ["adminUsers"],
        queryFn: fetchAdminUsers,
        staleTime: Infinity,
        gcTime: Infinity
    });
};
